import { z } from 'zod';

export const auditEntrySchema = z.object({
  id: z.string(),
  actorType: z.enum(['user', 'api_key', 'system', 'webhook']),
  actorId: z.string().nullable(),
  entity: z.string(),
  entityId: z.string(),
  action: z.string(),
  before: z.unknown().nullable(),
  after: z.unknown().nullable(),
  requestId: z.string().nullable(),
  at: z.string(),
});

export type AuditEntryDto = z.infer<typeof auditEntrySchema>;

export const auditPageSchema = z.object({
  items: z.array(auditEntrySchema),
  /** Curseur opaque de la page suivante, nul en fin de liste. */
  nextCursor: z.string().nullable(),
});

export const auditQuerySchema = z.object({
  entity: z.string().optional(),
  entityId: z.string().optional(),
  actorId: z.string().optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});
